import routes, { RouteOptions } from 'js/core_pre_webpack/routes';
import { keptAlivePost } from 'js/utils/kept_alive_post';

type DismissibleData = {
  RefutationFinderDraftRunSurvey: undefined;
  CitationsDashboardFeedback: undefined;
};

type Dismissible = keyof DismissibleData;

interface Show<T extends Dismissible> {
  show: true;
  data: DismissibleData[T];
}
interface DontShow {
  show: false;
}

type UserDismissibleResponse<T extends Dismissible> = Show<T> | DontShow;

export const showIfAppropriate = <T extends Dismissible>(
  nagName: T,
  showNagCallBack: (data: DismissibleData[T]) => void,
): Promise<void | undefined> => {
  const url = routes.api_v0_user_dismissible_path(params(nagName));

  return fetch(url)
    .then((res) => res.json())
    .then((json: UserDismissibleResponse<T>) => {
      if (json.show && showNagCallBack) {
        showNagCallBack(json.data);
      }
    });
};

export const recordShow = (nagName: string): Promise<object> => {
  const url = routes.record_show_api_v0_user_dismissibles_path(params(nagName));
  return keptAlivePost(url, {}) as Promise<object>;
};

export const recordDismissal = (nagName: string): Promise<object> => {
  const url = routes.record_dismissal_api_v0_user_dismissibles_path(
    params(nagName),
  );
  return keptAlivePost(url, {}) as Promise<object>;
};

export const recordClickthrough = (
  nagName: string,
  extraData?: object,
): void => {
  extraData =
    typeof extraData !== 'undefined'
      ? { extra_data: JSON.stringify(extraData) }
      : {};
  const data = { ...params(nagName), ...extraData };
  const url = routes.record_clickthrough_api_v0_user_dismissibles_path(data);
  keptAlivePost(url, {});
};

export const resetShow = (nagName: string): Promise<object> => {
  const url = routes.reset_show_count_api_v0_user_dismissibles_path(
    params(nagName),
  );
  return keptAlivePost(url, {}) as Promise<object>;
};

export const params = (
  nagName: string,
): RouteOptions & Record<'user_id' | 'id', string> => {
  const urlParams = {
    user_id: String(window.Aedu?.User?.current?.id ?? 'logged-out'),
    id: nagName,
    href: window.location.href,
    subdomain_param: 'api',
    auvid: window.$auvid,
    hit_id: undefined as number | undefined,
  };

  if (window.Aedu?.hit_data) {
    urlParams.hit_id = window.Aedu.hit_data.id;
  }

  return urlParams;
};
